/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderDiscountType = {
    ORDER: 'ORDER',
    DELIVERY: 'DELIVERY',
    PAYMENT: 'PAYMENT',
    SALES_TAX: 'SALES_TAX',
    CATEGORY: 'CATEGORY',
    MENU_ITEM: 'MENU_ITEM',
    CUSTOMIZATION_ITEM: 'CUSTOMIZATION_ITEM'
} as const;
export type OrderDiscountType = typeof OrderDiscountType[keyof typeof OrderDiscountType];


export function instanceOfOrderDiscountType(value: any): boolean {
    for (const key in OrderDiscountType) {
        if (Object.prototype.hasOwnProperty.call(OrderDiscountType, key)) {
            if (OrderDiscountType[key as keyof typeof OrderDiscountType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderDiscountTypeFromJSON(json: any): OrderDiscountType {
    return OrderDiscountTypeFromJSONTyped(json, false);
}

export function OrderDiscountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDiscountType {
    return json as OrderDiscountType;
}

export function OrderDiscountTypeToJSON(value?: OrderDiscountType | null): any {
    return value as any;
}

export function OrderDiscountTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderDiscountType {
    return value as OrderDiscountType;
}

